export default {
  mixed: {
    required: 'Dieses Feld ist erforderlich',
    default: 'Ungültiges Feld'
  },
  string: {
    min: ({ min }) => `Dieses Feld muss mindestens ${min} Zeichen lang sein`,
    max: ({ max }) => `Dieses Feld darf höchstens ${max} Zeichen lang sein`,
    email: 'Bitte geben Sie eine gültige E-Mail-Adresse an'
  },
  number: {
    min: ({ min }) => `Dieses Feld muss mindestens ${min} sein`,
    max: ({ max }) => `Dieses Feld darf höchstens ${max} sein`
  }
}
